import { Controller } from "@hotwired/stimulus"
import { replayAnimation } from "../lib/motion"

// Single-file drop zone (listing wizard credential): the chosen photo replaces the placeholder icon, a scan
// line sweeps it once and the file name takes the label's place. The real <input type=file> stays in the form.
export default class extends Controller {
  static targets = ["input", "preview", "name"]

  disconnect() {
    this.revoke()
  }

  // Dropping a file on the zone picks it (instead of the browser opening it and leaving the wizard).
  dragover(event) {
    event.preventDefault()
    this.element.classList.add("is-dragover")
  }

  dragleave() {
    this.element.classList.remove("is-dragover")
  }

  drop(event) {
    event.preventDefault()
    this.element.classList.remove("is-dragover")
    if (!event.dataTransfer?.files?.length) return
    this.inputTarget.files = event.dataTransfer.files
    this.pick()
  }

  pick() {
    const file = this.inputTarget.files?.[0]
    this.revoke()
    this.previewTarget.style.backgroundImage = ""
    if (!file) {
      this.nameTarget.textContent = this.nameTarget.dataset.emptyLabel
      this.element.classList.remove("is-filled")
      return
    }

    this.nameTarget.textContent = file.name
    if (file.type.startsWith("image/")) {
      this.objectUrl = URL.createObjectURL(file)
      this.previewTarget.style.backgroundImage = `url("${this.objectUrl}")`
    }
    this.element.classList.add("is-filled")
    replayAnimation(this.element, "is-scanning")
  }

  revoke() {
    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl)
    this.objectUrl = null
  }
}
